import classNames from 'classnames';
import React from 'react';
import styles from '../styles.module.css';
import customElementBoolAttr from '../utils/customElementBoolAttr';
import { svgToIcon } from '../utils/svg';
import ToolButton from './ToolButton';

interface ToggleToolButtonProps {
  name: string;
  icon: any;
  active: boolean;
  enabled: boolean;
  onClick: () => void;
  testId?: string;
}

const ToggleToolButton: React.FC<ToggleToolButtonProps> = ({
  name,
  icon,
  active,
  enabled,
  onClick,
  testId,
}) => {
  return (
    <ToolButton
      className={classNames(styles.toolButtonWide, styles.toolButtonConfig)}
      onClick={onClick}
      disabled={!enabled}
    >
      <span
        className={classNames(styles.toolButtonConfigText, {
          [styles.toolButtonConfigTextActive]: active,
        })}
      >
        {svgToIcon(icon)}
        {name}
      </span>
      <aha-switch
        data-testid={testId}
        active={customElementBoolAttr(active)}
        disabled={customElementBoolAttr(!enabled)}
      />
    </ToolButton>
  );
};

export default ToggleToolButton;
